/* =========================================================================
   AimGrips University — blog hub filtering/search + article TOC.
   Vanilla JS, no dependencies. Progressive enhancement: if JS fails the page
   still shows every article and reads fine.
   ========================================================================= */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----------------------------------------------------------------------
     BLOG HUB: category tabs (single-select) + topic cards + search +
     "More filters" checklists + sort + URL hash sync (#c=slug).
     Each card carries its searchable text + structured tags in data-* attrs
     written by the Liquid template (snippets/aga-article-card.liquid).
     Filter logic: tab AND search AND (OR within a checklist group, AND across).
     The audit promo card (data-aga-promo) is never tag-filtered; it hides only
     during an active text search so search results stay clean.
     ---------------------------------------------------------------------- */
  function initHub() {
    var hub = document.querySelector('[data-aga-hub]');
    if (!hub) return;

    var searchInput = hub.querySelector('[data-aga-search]');
    var clearBtn = hub.querySelector('[data-aga-search-clear]');
    var resetBtn = hub.querySelector('[data-aga-reset]');
    var emptyResetBtn = hub.querySelector('[data-aga-reset-empty]');
    var checks = Array.prototype.slice.call(hub.querySelectorAll('[data-aga-filter]'));
    var dropdowns = Array.prototype.slice.call(hub.querySelectorAll('[data-aga-dd]'));
    var tabs = Array.prototype.slice.call(hub.querySelectorAll('[data-aga-tab]'));
    var topics = Array.prototype.slice.call(hub.querySelectorAll('[data-aga-topic]'));
    var countEl = hub.querySelector('[data-aga-count]');
    var emptyEl = hub.querySelector('[data-aga-empty]');
    var mainGrid = hub.querySelector('[data-aga-grid="filterable"]');
    var cards = mainGrid ? Array.prototype.slice.call(mainGrid.querySelectorAll('[data-aga-card]')) : [];
    var promo = mainGrid ? mainGrid.querySelector('[data-aga-promo]') : null;
    var library = document.getElementById('aga-library');
    var sortSelect = hub.querySelector('[data-aga-sort]');

    var activeTab = '';   // '' = All; otherwise a raw tag like "category:aim-training"
    var active = {};      // checklist group -> array of checked values

    function slugOf(tag) { return (tag || '').replace(/^category:/, ''); }

    function applySort() {
      if (!sortSelect || !mainGrid) return;
      var val = sortSelect.value;
      var items = Array.prototype.slice.call(mainGrid.querySelectorAll('[data-aga-card]'));
      items.sort(function (a, b) {
        if (val === 'oldest' || val === 'newest') {
          var da = parseInt(a.getAttribute('data-date') || '0', 10);
          var db = parseInt(b.getAttribute('data-date') || '0', 10);
          return val === 'newest' ? db - da : da - db;
        }
        var ta = (a.getAttribute('data-title') || '').toLowerCase();
        var tb = (b.getAttribute('data-title') || '').toLowerCase();
        return val === 'az' ? ta.localeCompare(tb) : tb.localeCompare(ta);
      });
      items.forEach(function (it) { mainGrid.appendChild(it); }); // reorder in place
      // keep the promo card at its configured 1-based slot after any reorder
      if (promo) {
        var pos = parseInt(promo.getAttribute('data-aga-promo') || '5', 10);
        mainGrid.appendChild(promo);
        var ref = mainGrid.children[Math.min(pos - 1, mainGrid.children.length - 1)];
        if (ref && ref !== promo) mainGrid.insertBefore(promo, ref);
      }
    }

    function readState() {
      active = {};
      checks.forEach(function (cb) {
        if (cb.checked) {
          var group = cb.getAttribute('data-group');
          (active[group] = active[group] || []).push(cb.value);
        }
      });
    }

    function matches(card) {
      var q = (searchInput && searchInput.value || '').trim().toLowerCase();
      if (q) {
        var hay = (card.getAttribute('data-search') || '').toLowerCase();
        var terms = q.split(/\s+/);
        for (var i = 0; i < terms.length; i++) {
          if (hay.indexOf(terms[i]) === -1) return false;
        }
      }
      var cardTags = (card.getAttribute('data-tags') || '').split('|');
      if (activeTab && cardTags.indexOf(activeTab) === -1) return false;
      for (var group in active) {
        if (!active.hasOwnProperty(group)) continue;
        var want = active[group], hit = false;
        for (var j = 0; j < want.length; j++) {
          if (cardTags.indexOf(want[j]) !== -1) { hit = true; break; }
        }
        if (!hit) return false; // OR within a group, AND across groups
      }
      return true;
    }

    function anyFilterActive() {
      if (activeTab) return true;
      if (searchInput && searchInput.value.trim()) return true;
      for (var g in active) { if (active.hasOwnProperty(g) && active[g].length) return true; }
      return false;
    }

    function updateBadges() {
      dropdowns.forEach(function (dd) {
        var n = dd.querySelectorAll('[data-aga-filter]:checked').length;
        var badge = dd.querySelector('[data-aga-dd-badge]');
        var toggle = dd.querySelector('[data-aga-dd-toggle]');
        if (badge) { badge.textContent = n; badge.hidden = n === 0; }
        if (toggle) toggle.classList.toggle('aga-dd-toggle--active', n > 0);
      });
    }

    function syncHash() {
      if (!window.history || !window.history.replaceState) return;
      var base = window.location.pathname + window.location.search;
      if (activeTab) window.history.replaceState(null, '', base + '#c=' + encodeURIComponent(slugOf(activeTab)));
      else window.history.replaceState(null, '', base);
    }

    var swapT;
    function apply() {
      readState();
      if (mainGrid && !reduceMotion) {
        mainGrid.classList.add('is-swapping');
        clearTimeout(swapT);
        swapT = setTimeout(function () { mainGrid.classList.remove('is-swapping'); }, 190);
      }
      var visible = 0;
      cards.forEach(function (card) {
        var show = matches(card);
        card.hidden = !show;
        if (show) visible++;
      });
      var searching = !!(searchInput && searchInput.value.trim());
      if (promo) promo.hidden = searching || visible === 0;
      if (countEl) countEl.textContent = visible + (visible === 1 ? ' guide' : ' guides');
      if (emptyEl) emptyEl.hidden = visible !== 0;
      if (clearBtn) clearBtn.hidden = !searching;
      if (resetBtn) resetBtn.hidden = !anyFilterActive();
      updateBadges();
    }

    function setTab(value, opts) {
      opts = opts || {};
      activeTab = value || '';
      tabs.forEach(function (t) {
        var on = (t.getAttribute('data-aga-tab') || '') === activeTab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      topics.forEach(function (tp) {
        tp.classList.toggle('is-active', (tp.getAttribute('data-aga-topic') || '') === activeTab && activeTab !== '');
      });
      apply();
      if (!opts.silent) syncHash();
      if (opts.scroll && library) {
        library.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
    }

    // dropdown open/close
    function closeAll(except) {
      dropdowns.forEach(function (dd) {
        if (dd === except) return;
        var panel = dd.querySelector('[data-aga-dd-panel]');
        var toggle = dd.querySelector('[data-aga-dd-toggle]');
        if (panel) panel.hidden = true;
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    }
    dropdowns.forEach(function (dd) {
      var toggle = dd.querySelector('[data-aga-dd-toggle]');
      var panel = dd.querySelector('[data-aga-dd-panel]');
      if (!toggle || !panel) return;
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = panel.hidden;
        closeAll(dd);
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      panel.addEventListener('click', function (e) { e.stopPropagation(); });
    });
    document.addEventListener('click', function () { closeAll(null); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { setTab(t.getAttribute('data-aga-tab') || ''); });
    });
    topics.forEach(function (tp) {
      tp.addEventListener('click', function () { setTab(tp.getAttribute('data-aga-topic') || '', { scroll: true }); });
    });
    checks.forEach(function (cb) { cb.addEventListener('change', apply); });
    if (sortSelect) sortSelect.addEventListener('change', applySort);

    if (searchInput) {
      var t;
      searchInput.addEventListener('input', function () { clearTimeout(t); t = setTimeout(apply, 120); });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function () { if (searchInput) { searchInput.value = ''; searchInput.focus(); } apply(); });
    }
    function resetAll() {
      if (searchInput) searchInput.value = '';
      checks.forEach(function (c) { c.checked = false; });
      closeAll(null);
      setTab('');
    }
    if (resetBtn) resetBtn.addEventListener('click', resetAll);
    if (emptyResetBtn) emptyResetBtn.addEventListener('click', resetAll);

    // deep-link: restore a category tab from the URL hash (#c=slug)
    var m = /^#c=([\w%-]+)$/.exec(window.location.hash || '');
    if (m) {
      var wanted = 'category:' + decodeURIComponent(m[1]);
      var found = null;
      tabs.forEach(function (t) { if ((t.getAttribute('data-aga-tab') || '') === wanted) found = t; });
      if (found) { setTab(wanted, { silent: true }); return; }
    }
    apply();
  }

  /* ----------------------------------------------------------------------
     ARTICLE: build Table of Contents from H2/H3 inside .aga-content,
     scroll-spy the active heading, and wire the mobile collapse toggle.
     ---------------------------------------------------------------------- */
  function slugify(s, used) {
    var base = (s || 'section').toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || 'section';
    var id = base, n = 2;
    while (used[id]) { id = base + '-' + n; n++; }
    used[id] = true;
    return id;
  }

  function initToc() {
    var toc = document.querySelector('[data-aga-toc]');
    var content = document.querySelector('[data-aga-content]');
    if (!toc || !content) return;

    // only real section headings — skip headings that live inside content
    // components (product callouts, answer/definition/callout boxes, placeholders)
    var SKIP = '.aga-product-callout, .aga-answer-box, .aga-definition-box, .aga-callout-box, .aga-real-image-placeholder, .aga-generated-image-placeholder';
    var headings = Array.prototype.slice.call(content.querySelectorAll('h2, h3')).filter(function (h) {
      return !(h.closest && h.closest(SKIP));
    });
    var listWrap = toc.querySelector('[data-aga-toc-list]');
    if (!headings.length || !listWrap) {
      toc.hidden = true; // nothing to navigate
      return;
    }

    var used = {};
    var ol = document.createElement('ol');
    var links = [];

    headings.forEach(function (h) {
      if (!h.id) h.id = slugify(h.textContent, used);
      else used[h.id] = true;
      var li = document.createElement('li');
      if (h.tagName.toLowerCase() === 'h3') li.className = 'aga-toc-h3';
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      a.addEventListener('click', function () {
        // close the mobile drawer after a jump
        if (window.matchMedia('(max-width: 999px)').matches) {
          toc.setAttribute('data-collapsed', 'true');
        }
      });
      li.appendChild(a);
      ol.appendChild(li);
      links.push({ a: a, h: h });
    });

    listWrap.innerHTML = '';
    listWrap.appendChild(ol);

    // scroll-spy — highlight the last heading scrolled past the top offset,
    // rAF-throttled so it stays in sync with the page scroll. Also nudges the
    // sticky rail so the active item stays visible without moving the page.
    var ticking = false, lastIdx = -2;
    function updateActive() {
      ticking = false;
      var offset = 110; // a heading counts as "current" once its top passes this
      var currentIdx = -1;
      for (var i = 0; i < links.length; i++) {
        if (links[i].h.getBoundingClientRect().top - offset <= 0) currentIdx = i;
        else break;
      }
      // only touch the DOM when the active section actually changes — updating on every
      // frame (and nudging toc.scrollTop incrementally) is what broke on fast scroll-up.
      if (currentIdx === lastIdx) return;
      lastIdx = currentIdx;
      for (var j = 0; j < links.length; j++) {
        links[j].a.classList.toggle('aga-toc-active', j === currentIdx);
      }
      // keep the active item visible in the sticky rail with a single absolute set
      // (never incremental, never scrolls the page)
      if (currentIdx >= 0 && toc.scrollHeight > toc.clientHeight + 4) {
        var al = links[currentIdx].a;
        var target = al.offsetTop - (toc.clientHeight / 2) + (al.offsetHeight / 2);
        toc.scrollTop = Math.max(0, target);
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(updateActive); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateActive();

    // mobile collapse toggle
    var toggle = toc.querySelector('[data-aga-toc-toggle]');
    if (toggle) {
      if (window.matchMedia('(max-width: 999px)').matches) {
        toc.setAttribute('data-collapsed', 'true');
      }
      toggle.addEventListener('click', function () {
        var collapsed = toc.getAttribute('data-collapsed') === 'true';
        toc.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
      });
    }
  }

  /* ----------------------------------------------------------------------
     Backward-compat: articles authored before the prefix was renamed to `aga-`
     use legacy `ag-` component classes in their body HTML (ag-answer-box,
     ag-product-callout, ag-button, etc.). Upgrade them so they keep rendering
     without manually editing old posts. Idempotent; only touches legacy classes.
     ---------------------------------------------------------------------- */
  function upgradeLegacyClasses() {
    var content = document.querySelector('[data-aga-content]');
    if (!content) return;
    var els = content.querySelectorAll('[class*="ag-"]');
    Array.prototype.forEach.call(els, function (el) {
      if (el.className && typeof el.className === 'string') {
        el.className = el.className.replace(/(^|\s)ag-/g, '$1aga-');
      }
    });
  }

  /* ----------------------------------------------------------------------
     INTERACTIONS (progressive enhancement — all no-ops if unsupported or if
     the user prefers reduced motion). Adds: scroll-reveal, article reading
     progress bar, back-to-top button, and a hero cursor spotlight.
     ---------------------------------------------------------------------- */

  // Fade/slide elements in as they enter the viewport.
  function initReveal() {
    var root = document.querySelector('.aga-academy');
    if (!root || reduceMotion || !('IntersectionObserver' in window)) return;
    var SEL = '.aga-card, .aga-topic, .aga-strip-item, .aga-endcta, .aga-callout, .aga-product-card, .aga-article-feature, .aga-audit-chip, .aga-faq details, .aga-faq-item, .aga-section-head, .aga-final-cta';
    var els = Array.prototype.slice.call(root.querySelectorAll(SEL));
    if (!els.length) return;
    // .aga-anim enables the hidden→reveal state; without it (JS off/failed) content shows.
    root.classList.add('aga-anim');
    els.forEach(function (el) { el.classList.add('aga-reveal'); });
    function reveal(el) { el.classList.add('is-in'); }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
    // reveal anything already at/above the fold right away (don't wait for a scroll)
    requestAnimationFrame(function () {
      els.forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.92) { reveal(el); io.unobserve(el); }
      });
    });
    // failsafe: if IO never fires (rare webviews), never leave content hidden
    setTimeout(function () { els.forEach(reveal); }, 2600);
  }

  // Reading progress bar + back-to-top, article pages only.
  function initArticleChrome() {
    var article = document.querySelector('.aga-article');
    if (!article) return;

    var bar = document.createElement('div');
    bar.className = 'aga-progress';
    var fill = document.createElement('span');
    bar.appendChild(fill);
    document.body.appendChild(bar);

    var toTop = document.createElement('button');
    toTop.type = 'button';
    toTop.className = 'aga-totop';
    toTop.setAttribute('aria-label', 'Back to top');
    toTop.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    toTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    document.body.appendChild(toTop);

    var ticking = false;
    function update() {
      ticking = false;
      var rect = article.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var scrolled = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
      var pct = total > 0 ? (scrolled / total) * 100 : 0;
      fill.style.width = pct + '%';
      toTop.classList.toggle('is-visible', window.pageYOffset > 600);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  // Hero glow follows the cursor (desktop, motion-friendly only).
  function initHeroSpotlight() {
    if (reduceMotion) return;
    var hero = document.querySelector('.aga-hero');
    if (!hero || !window.matchMedia('(hover: hover)').matches) return;
    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      hero.style.setProperty('--aga-mx', ((e.clientX - r.left) / r.width * 100) + '%');
      hero.style.setProperty('--aga-my', ((e.clientY - r.top) / r.height * 100) + '%');
    });
    hero.addEventListener('pointerleave', function () {
      hero.style.setProperty('--aga-mx', '50%');
      hero.style.setProperty('--aga-my', '0%');
    });
  }

  // Masthead background video: never autoplay for reduced-motion visitors.
  function initHeroVideo() {
    var video = document.querySelector('.aga-hero > video.aga-hero-bg');
    if (!video) return;
    if (reduceMotion) {
      video.pause();
      video.removeAttribute('autoplay');
      return;
    }
    // some mobile browsers ignore the autoplay attribute on late-inserted video
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  // Rotating hook line under the masthead title — cycles player pain points to
  // hook readers into scrolling. Fail-safe: first line always renders even if
  // JS never runs (see the Liquid <ul> fallback content); reduced-motion shows
  // just the first line, no cycling.
  function initHeroRotator() {
    var root = document.querySelector('[data-aga-rotator]');
    if (!root) return;
    var items = Array.prototype.slice.call(root.querySelectorAll('.aga-mast-rotator-list li'))
      .map(function (li) { return li.textContent.trim(); })
      .filter(Boolean);
    var live = root.querySelector('.aga-mast-rotator-live');
    if (!items.length || !live) return;
    live.textContent = items[0];
    if (items.length < 2 || reduceMotion) return;
    var i = 0;
    setInterval(function () {
      live.classList.add('is-out');
      setTimeout(function () {
        i = (i + 1) % items.length;
        live.textContent = items[i];
        live.classList.remove('is-out');
      }, 350);
    }, 3200);
  }

  // Sticky micro-CTA bar: appears after the reader scrolls past the first
  // screen, hides whenever the final CTA is on screen (no doubled pitch), and
  // stays dismissed for the rest of the browsing session once closed.
  function initStickyBar() {
    var bar = document.querySelector('[data-aga-stickybar]');
    if (!bar) return;
    var KEY = 'agaStickyDismissed';
    try { if (sessionStorage.getItem(KEY)) return; } catch (e) { /* storage blocked — just show */ }
    var endcta = document.querySelector('[data-aga-endcta]');
    var closeBtn = bar.querySelector('[data-aga-stickybar-close]');
    bar.hidden = false;

    var ticking = false, dismissed = false;
    function update() {
      ticking = false;
      if (dismissed) return;
      var past = window.pageYOffset > window.innerHeight * 1.1;
      var overlapped = false;
      if (endcta) {
        var r = endcta.getBoundingClientRect();
        overlapped = r.top < window.innerHeight && r.bottom > 0;
      }
      bar.classList.toggle('is-visible', past && !overlapped);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dismissed = true;
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        bar.classList.remove('is-visible');
        try { sessionStorage.setItem(KEY, '1'); } catch (e) { /* ignore */ }
        setTimeout(function () { bar.hidden = true; }, 320);
      });
    }
  }

  function escHtml(s) {
    return (s || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // Search typeahead: as the user types in the masthead search, show a dropdown
  // of matching guides (headlines) + topics (category filters), built live from
  // the cards already on the page. Panel is appended to the .aga-academy ROOT
  // (not inside the hero, whose overflow:hidden would clip it) and positioned
  // under the search box. The grid still filters underneath as before.
  function initSearchSuggest() {
    var hub = document.querySelector('[data-aga-hub]');
    if (!hub) return;
    var input = hub.querySelector('[data-aga-search]');
    var box = hub.querySelector('.aga-search-box');
    var root = document.querySelector('.aga-academy');
    if (!input || !box || !root) return;

    // index every guide card in the filterable grid (title + url + haystack + category)
    var items = Array.prototype.slice.call(hub.querySelectorAll('[data-aga-grid="filterable"] [data-aga-card]')).map(function (c) {
      var link = c.querySelector('.aga-card-title a');
      var catEl = c.querySelector('.aga-badge-category');
      return {
        title: link ? link.textContent.trim() : (c.getAttribute('data-title') || ''),
        url: link ? link.getAttribute('href') : '#',
        hay: (c.getAttribute('data-search') || '').toLowerCase(),
        cat: catEl ? catEl.textContent.trim() : ''
      };
    });
    // category filters from the tab bar (skip the "All" tab)
    var cats = Array.prototype.slice.call(hub.querySelectorAll('[data-aga-tab]'))
      .filter(function (t) { return (t.getAttribute('data-aga-tab') || '') !== ''; })
      .map(function (t) {
        return { label: t.textContent.replace(/\s*\d+\s*$/, '').trim(), tag: t.getAttribute('data-aga-tab') };
      });

    var panel = document.createElement('div');
    panel.className = 'aga-search-suggest';
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    root.appendChild(panel);

    var links = [], activeIdx = -1;

    function position() {
      var rr = root.getBoundingClientRect();
      var br = box.getBoundingClientRect();
      panel.style.top = (br.bottom - rr.top + 8) + 'px';
      panel.style.left = (br.left - rr.left) + 'px';
      panel.style.width = br.width + 'px';
    }
    function close() { panel.hidden = true; activeIdx = -1; links = []; }
    function highlight() {
      links.forEach(function (l, i) {
        l.classList.toggle('is-active', i === activeIdx);
        if (i === activeIdx) l.scrollIntoView({ block: 'nearest' });
      });
    }

    function render() {
      var q = input.value.trim().toLowerCase();
      if (q.length < 2) { close(); return; }
      var terms = q.split(/\s+/);
      function matchAll(hay) {
        for (var i = 0; i < terms.length; i++) { if (hay.indexOf(terms[i]) === -1) return false; }
        return true;
      }
      var guides = items.filter(function (it) { return matchAll(it.hay); }).slice(0, 6);
      var topics = cats.filter(function (c) { return c.label.toLowerCase().indexOf(q) !== -1; }).slice(0, 4);

      if (!guides.length && !topics.length) {
        panel.innerHTML = '<p class="aga-suggest-empty">No matches — press Enter to browse all guides.</p>';
        links = []; activeIdx = -1; position(); panel.hidden = false; return;
      }

      var html = '';
      if (topics.length) {
        html += '<p class="aga-suggest-group">Topics</p><div class="aga-suggest-cats">';
        html += topics.map(function (c) {
          return '<button type="button" class="aga-suggest-cat-chip" data-suggest-cat="' + escHtml(c.tag) + '">' + escHtml(c.label) + '</button>';
        }).join('');
        html += '</div>';
      }
      if (guides.length) {
        html += '<p class="aga-suggest-group">Guides</p>';
        html += guides.map(function (it) {
          return '<a class="aga-suggest-item" href="' + escHtml(it.url) + '"><span class="aga-suggest-title">' + escHtml(it.title) + '</span>' +
            (it.cat ? '<span class="aga-suggest-cat">' + escHtml(it.cat) + '</span>' : '') + '</a>';
        }).join('');
      }
      panel.innerHTML = html;
      links = Array.prototype.slice.call(panel.querySelectorAll('.aga-suggest-item'));
      activeIdx = -1;

      // topic chip → apply that category tab, clear the text search, close
      Array.prototype.forEach.call(panel.querySelectorAll('[data-suggest-cat]'), function (chip) {
        chip.addEventListener('click', function () {
          var tab = hub.querySelector('[data-aga-tab="' + chip.getAttribute('data-suggest-cat') + '"]');
          input.value = '';
          input.dispatchEvent(new Event('input', { bubbles: true }));
          if (tab) tab.click();
          close();
          if (tab) tab.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        });
      });

      position(); panel.hidden = false;
    }

    var t;
    input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(render, 100); });
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2) render(); });
    input.addEventListener('keydown', function (e) {
      if (panel.hidden || !links.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); activeIdx = Math.min(activeIdx + 1, links.length - 1); highlight(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); activeIdx = Math.max(activeIdx - 1, 0); highlight(); }
      else if (e.key === 'Enter') { if (activeIdx >= 0 && links[activeIdx]) { window.location.href = links[activeIdx].getAttribute('href'); } }
      else if (e.key === 'Escape') { close(); }
    });
    document.addEventListener('click', function (e) {
      if (e.target !== input && !panel.contains(e.target) && !box.contains(e.target)) close();
    });
    window.addEventListener('resize', function () { if (!panel.hidden) position(); });
  }

  // Scroll cue: nudge readers to the content right after the masthead.
  function initScrollCue() {
    var btn = document.querySelector('[data-aga-scroll-next]');
    var hero = btn && btn.closest('.aga-hero');
    if (!btn || !hero) return;
    btn.addEventListener('click', function () {
      var next = hero.nextElementSibling;
      if (next) next.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    upgradeLegacyClasses();
    initHub();
    initToc();
    initReveal();
    initArticleChrome();
    initHeroSpotlight();
    initHeroVideo();
    initHeroRotator();
    initScrollCue();
    initStickyBar();
    initSearchSuggest();
  });
})();
